import type { Service } from '../types';

export const services: Service[] = [
  {
    id: 'lead-rescue-system',
    name: 'Missed Call & Lead Rescue System',
    description: 'Stop losing new clients to missed calls and forgotten messages. A simple SMS and follow-up layer around your existing booking system.',
    features: [
      'Automatic missed call text-back',
      'Instant website inquiry replies',
      'Simple lead log and tracking',
      'Gentle follow-up messages',
      '24-hour implementation (Lead Rescue only)'
    ],
    image: 'https://images.unsplash.com/photo-1556742111-a301076d9d18?auto=format&fit=crop&q=80&w=800'
  },
  {
    id: 'chatbots-phone-agents',
    name: 'Chatbots & Phone Agents',
    description: 'Handle FAQs, qualify leads, route calls, and reduce repetitive tasks for your team. Usually comes after basic lead capture is in place.',
    features: [
      'FAQ handling and responses',
      'Lead qualification',
      'Call routing and management',
      'Appointment booking assistance',
      'Custom conversation flows'
    ],
    image: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&q=80&w=800'
  },
  {
    id: 'websites-landing-pages',
    name: 'Websites & Landing Pages',
    description: 'Clean, conversion-focused sites for local service businesses. Fast loading, clear messaging, strong calls to action.',
    features: [
      'Mobile-responsive design',
      'Fast page loading',
      'Lead capture forms',
      'Clear messaging and CTAs',
      'Easy content updates'
    ],
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=800'
  },
  {
    id: 'custom-automations',
    name: 'Custom Automations & Systems',
    description: 'Connect your existing tools (booking platforms, CRMs, email, SMS) so your business runs smoother with less manual work.',
    features: [
      'Tool integration and connection',
      'Workflow automation',
      'Data synchronization',
      'Review request campaigns',
      'Reactivation sequences'
    ],
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=800'
  }
] as const;

export type ServiceId = typeof services[number]['id'];